export default __webpack_public_path__ + "static/media/SS.0a1ec114.ico";